import { render, staticRenderFns } from "./SelectCriterionTypeFilter.vue?vue&type=template&id=a4ffd624&scoped=true&"
import script from "./SelectCriterionTypeFilter.vue?vue&type=script&lang=ts&"
export * from "./SelectCriterionTypeFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ffd624",
  null
  
)

export default component.exports